/* unplugin-vue-components disabled */import script from "./cloudModel.vue?vue&type=script&lang=ts&setup=true"
export * from "./cloudModel.vue?vue&type=script&lang=ts&setup=true"

import "./cloudModel.vue?vue&type=style&index=0&id=2622902a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2622902a"]])

export default __exports__